import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { UserType } from './users-reducer';
import { useNavigate } from 'react-router-dom';

export const UserItem = (props: UserItemPropsType) => {
  const navigate = useNavigate()
  const userLocationState: UserLocationStateType = {
    user: props.user
  }

  return (
    <TableRow hover style={{ cursor: 'pointer' }} onClick={() => navigate(`/usersList/${props.user.id}`, { state: userLocationState })} >
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {props.user.id}
        </Typography>
      </TableCell>
      <TableCell >
        <Typography className='accountItem'>
          {props.user.firstName}
          {' '}
          {props.user.lastName}
        </Typography>
      </TableCell>
      {/* <TableCell style={{ textAlign: 'center' }}>
        <Typography className='accountItem'>
          {props.user.lastName}
        </Typography>
      </TableCell> */}
      {/* <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {props.user.description}
        </Typography>
      </TableCell> */}
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {props.user.roles}
        </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
          {props.user.projects.map(pr => {
            return <Typography key={pr.id}>{pr.projectName}</Typography> 
          })}
      </TableCell>
    </TableRow>
  )
}


type UserItemPropsType = {
  user: UserType
}

export type UserLocationStateType = {
  user: UserType
}